'use client'

// THEME COMPLIANCE: All UI implementations must support both dark and light themes.

import { Layers } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useNavTheme } from '@/lib/context/NavThemeContext'

interface TransferLayoutToggleProps {
  className?: string
}

/**
 * Toggles the Transfer Market page between Layout 1 (current) and Layout 2 (the
 * legacy ~June 2026 snapshot). Rendered in the navbar only on the transfers page.
 */
export function TransferLayoutToggle({ className }: TransferLayoutToggleProps) {
  const { transferLayout, setTransferLayout } = useNavTheme()
  const next = transferLayout === 1 ? 2 : 1
  const label = `Transfer layout ${transferLayout} — switch to layout ${next}`

  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      onClick={() => setTransferLayout(next)}
      className={cn(
        'relative inline-flex h-9 w-9 items-center justify-center rounded-full border border-border/60 text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        className
      )}
    >
      <Layers className="h-4 w-4" />
      <span className="absolute -bottom-0.5 -right-0.5 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-primary text-[8px] font-bold leading-none text-primary-foreground">
        {transferLayout}
      </span>
      <span className="sr-only">{label}</span>
    </button>
  )
}
